<template>
  <div class="imei-history-cell">
    <div v-if="!displayCodes.length" class="text-muted">—</div>
    <template v-else>
      <div class="imei-history-cell__summary">
        {{ displayCodes.length }} IMEI
        <button
          v-if="displayCodes.length > collapsedLimit"
          type="button"
          class="btn btn-link btn-sm p-0 ml-1 imei-history-cell__toggle"
          @click="expanded = !expanded"
        >
          {{ expanded ? 'Thu gọn' : 'Xem danh sách' }}
        </button>
      </div>
      <ul
        v-if="expanded || displayCodes.length <= collapsedLimit"
        class="imei-history-cell__list mb-0"
      >
        <li
          v-for="(code, index) in visibleCodes"
          :key="`${side}-${code}-${index}`"
          :class="imeiItemClass(code)"
        >
          <span class="imei-history-cell__stt">{{ index + 1 }}.</span>
          <span class="imei-history-cell__code">{{ code }}</span>
          <span v-if="imeiTag(code)" class="imei-history-cell__tag">{{ imeiTag(code) }}</span>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'ImeiHistoryCell',
    props: {
      codes: {
        type: Array,
        default: () => [],
      },
      imeiDiff: {
        type: Object,
        default: null,
      },
      side: {
        type: String,
        default: 'before',
      },
      collapsedLimit: {
        type: Number,
        default: 5,
      },
    },
    data() {
      return {
        expanded: false,
      }
    },
    computed: {
      displayCodes() {
        return Array.isArray(this.codes) ? this.codes : []
      },
      visibleCodes() {
        if (this.expanded || this.displayCodes.length <= this.collapsedLimit) {
          return this.displayCodes
        }
        return this.displayCodes.slice(0, this.collapsedLimit)
      },
      addedSet() {
        return new Set(this.imeiDiff?.added || [])
      },
      removedSet() {
        return new Set(this.imeiDiff?.removed || [])
      },
    },
    methods: {
      imeiItemClass(code) {
        if (!this.imeiDiff?.changed) return ''
        if (this.side === 'after' && this.addedSet.has(code)) {
          return 'imei-history-cell__item--added'
        }
        if (this.side === 'before' && this.removedSet.has(code)) {
          return 'imei-history-cell__item--removed'
        }
        return ''
      },
      imeiTag(code) {
        if (!this.imeiDiff?.changed) return ''
        if (this.side === 'after' && this.addedSet.has(code)) return 'Mới'
        if (this.side === 'before' && this.removedSet.has(code)) return 'Đã bỏ'
        return ''
      },
    },
  }
</script>

<style scoped>
  .imei-history-cell__summary {
    font-size: 12px;
    color: #3f4254;
    margin-bottom: 4px;
  }
  .imei-history-cell__toggle {
    font-size: 12px;
    vertical-align: baseline;
  }
  .imei-history-cell__list {
    list-style: none;
    padding: 0;
    max-height: 160px;
    overflow-y: auto;
    font-size: 12px;
    line-height: 1.5;
  }
  .imei-history-cell__list li {
    display: flex;
    align-items: baseline;
    gap: 4px;
    padding: 2px 0;
    word-break: break-all;
  }
  .imei-history-cell__stt {
    color: #7e8299;
    min-width: 22px;
    flex-shrink: 0;
  }
  .imei-history-cell__code {
    font-family: monospace;
    font-size: 11px;
  }
  .imei-history-cell__tag {
    flex-shrink: 0;
    font-size: 10px;
    font-weight: 600;
    padding: 0 4px;
    border-radius: 3px;
  }
  .imei-history-cell__item--added {
    background: #e8fff3;
    border-radius: 3px;
    padding-left: 4px;
    padding-right: 4px;
  }
  .imei-history-cell__item--added .imei-history-cell__tag {
    background: #c3e6cb;
    color: #155724;
  }
  .imei-history-cell__item--removed {
    background: #fff0f0;
    border-radius: 3px;
    padding-left: 4px;
    padding-right: 4px;
    text-decoration: line-through;
    opacity: 0.85;
  }
  .imei-history-cell__item--removed .imei-history-cell__tag {
    background: #f5c6cb;
    color: #721c24;
  }
</style>
